import Paramawati1 from '../Paramawati/Paramawati (1).webp'
import Paramawati2 from '../Paramawati/Paramawati (2).webp'
import Paramawati3 from '../Paramawati/Paramawati (3).webp'
import Paramawati4 from '../Paramawati/Paramawati (4).webp'
import Paramawati5 from '../Paramawati/Paramawati (5).webp'
import Paramawati6 from '../Paramawati/Paramawati (6).webp'
import Paramawati7 from '../Paramawati/Paramawati (7).webp'
import Paramawati8 from '../Paramawati/Paramawati (8).webp'
import Paramawati9 from '../Paramawati/Paramawati (9).webp'
import Paramawati10 from '../Paramawati/Paramawati (10).webp'
import Paramawati11 from '../Paramawati/Paramawati (12).webp'




const Paramawatiimages =[
Paramawati1,Paramawati2,Paramawati3,Paramawati4,Paramawati5,Paramawati6,Paramawati7,Paramawati8,Paramawati9,Paramawati10,Paramawati11
]

export default Paramawatiimages;